/* eslint-disable camelcase */
/* eslint-disable react/prop-types */
import React, {
  useState,
  // Fragment
} from 'react'
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  // Table,
  // TableBody,
  // TableRow,
  // TableCell,
  DialogTitle,
} from '@material-ui/core'
import { useForm } from 'react-hook-form'
// import SelectApi from '@components/CustomFields/SelectApi'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { resellerApi } from '@api/baseApi'
import { useSnackbar } from 'notistack'
import FieldImageUploader2 from '@components/CustomFields/FieldImageUploader2'
import getDomain from '@config/domain'

const schema = yup.object().shape({
  customer_id: yup.string().required('tidak boleh kosong'),
  // bank_account_id: yup.mixed().required('tidak boleh kosong'),
  //   payment_slip: yup.mixed().required('Silahkan pilih bukti transfer')
  //     .test('fileSize', 'File bukti transfer maksmial 20mb', (value) => value && value[0].size <= 20000000)
  //     .test('type', 'File bukti transfer hanya berupa jpg/jpeg/png', (value) => value && ['image/jpeg', 'image/png'].includes(value[0].type)),
})

const PaymentConfirmationDialog = (props) => {
  const {
    open,
    onClose,
    data,
  } = props
  const { customer_id, registration_payment } = data
  const {
    handleSubmit, register, errors, setError,
  } = useForm({
    defaultValues: {
      customer_id,
      registration_payment: {
        id: registration_payment.id,
      },
    },
    resolver: yupResolver(schema),
  })
  // const [options, setOptions] = useState([])
  const [loading, setLoading] = useState(false)
  const [images, setImages] = useState(null)
  const { enqueueSnackbar } = useSnackbar()

  // const renderPaymentConfirm = () => (
  //   <Fragment>
  //     <h3>Bukti Transfer</h3>
  //     <Table className="table-product">
  //       <TableBody>
  //         <TableRow>
  //           <TableCell>Nomor Order</TableCell>
  //           <TableCell>{paymentConfirm?.order?.transaction_id}</TableCell>
  //         </TableRow>
  //         <TableRow>
  //           <TableCell>Bank</TableCell>
  //           <TableCell>{paymentConfirm?.bank_account_name}</TableCell>
  //         </TableRow>
  //         <TableRow>
  //           <TableCell>No Rekening</TableCell>
  //           <TableCell>{paymentConfirm?.bank_account_number}</TableCell>
  //         </TableRow>
  //         <TableRow>
  //           <TableCell>Bukti Transfer</TableCell>
  //           <TableCell>
  //             <img src={paymentConfirm?.payment_slip_images.standard} alt="bukti transfer" width={180} />
  //           </TableCell>
  //         </TableRow>
  //       </TableBody>
  //     </Table>
  //   </Fragment>
  // )

  // const getBanks = async () => {
  //   try {
  //     const { status, data: { data } } = await resellerApiWithToken.get('/resellers/bank_accounts/store_accounts', { params: { per_page: 100 } })
  //     if (status === 200) {
  //       setOptions(data)
  //     }
  //   } catch (error) {
  //     setOptions([])
  //   }
  // }

  // useEffect(() => {
  //   getBanks()
  // }, [])

  const onSubmit = async () => {
    if (images?.files?.length === 0) {
      setError('payment_slip', {
        type: 'manual',
        message: 'Silahkan pilih bukti transfer',
      })
    } else if (images?.files?.[0]?.size >= 20000000) {
      setError('payment_slip', {
        type: 'manual',
        message: 'File bukti transfer maksmial 20mb',
      })
    } else if (!['image/jpeg', 'image/png'].includes(images?.files?.[0]?.type)) {
      setError('payment_slip', {
        type: 'manual',
        message: 'File bukti transfer hanya berupa jpg/jpeg/png',
      })
    } else {
      const formData = new FormData()
      formData.append('registration_payment[payment_attachment]', images?.files?.[0])
      formData.append('registration_payment[id]', registration_payment.id)
      formData.append('id', registration_payment.id)
      formData.append('customer_id', customer_id)
      formData.append('domain', getDomain())
      try {
        setLoading(true)
        // eslint-disable-next-line no-unused-vars
        const { status } = await resellerApi.put(
          '/api/v1/resellers/registration_payments/upload_attachment',
          formData,
        )
        if (status === 200) {
          enqueueSnackbar('Berhasil upload bukti bayar', {
            variant: 'success',
          })
          setLoading(false)
          onClose()
        } else {
          setLoading(false)
          enqueueSnackbar('Maaf, gagal upload bukti bayar', {
            variant: 'error',
          })
        }
      } catch (error) {
        setLoading(false)
        enqueueSnackbar('Maaf, gagal upload bukti bayar', { variant: 'error' })
      }
    }
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Upload Bukti Pembayaran</DialogTitle>
      <DialogContent>
        <form onSubmit={handleSubmit(onSubmit)}>
          <input type="text" ref={register} name="customer_id" value={customer_id} hidden />
          {/* <SelectApi
            name="bank_account_id"
            label="Bank"
            placeholder="Cari Bank..."
            register={register}
            setValue={setValue}
            errors={errors}
            control={control}
            getOptionSelected={(value) => value.id}
            getOptionLabel={(value) => `${value.name} - ${value.bank_name} - ${value.number}`}
            options={options}
          /> */}
          <FieldImageUploader2
            errors={errors}
            name="payment_slip"
            label="Bukti Transfer"
            setValue={(e, i, d) => setImages({ name: e, files: i, d })}
            src=""
            placeholder="Upload bukti transfer"
          />
          <Box height={50} />
          <DialogActions>
            <Button type="submit" variant="contained" color="primary">
              {loading ? (
                <CircularProgress size={24} color="secondary" />
              ) : (
                'Submit'
              )}
            </Button>
            <Button onClick={onClose}>Tutup</Button>
          </DialogActions>
        </form>
      </DialogContent>
    </Dialog>
  )
}

export default PaymentConfirmationDialog
